module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#speaker",
      toString: function () {
        return this.url;
      }
    }